module.exports = {
    'lang': 'zh-cn',
    'title': '默认筛选',
    'resetName': '清空',
    'searchName': '查询',
    'down':'展开',
    'up':'收起',
    'en-us': {
        'title': 'screening conditions',
        'resetName': 'reset',
        'searchName': 'submit',
        'down':'open',
        'up':'close',
    },
    'zh-tw': {
        'title': '默認篩選',
        'resetName': '清空',
        'searchName': '查詢',
        'down':'展開',
        'up':'收起',
    },
}



// WEBPACK FOOTER //
// ./src/i18n.js